import styles from './style.postcss';

import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { testClass } from 'omni-common-ui';
import PropTypes from 'prop-types';
import { pure } from 'recompose';

const TAB_ITEM_ONCLICK_KEY = Symbol('Tabs#onClick');
const DRAG_DELTA_PX = 20;

let startMouseX = 0;

const wasLeftMouseButtonPressed = (e = window.event) => {
  const button = e.which || e.button;
  return button === 1;
};

const onMouseDown = (e = {}) => {
  if (! wasLeftMouseButtonPressed(e.nativeEvent)) return;
  startMouseX = e.screenX;
};

const onClick = (item, e = {}) => {
  const movement = Math.abs(startMouseX - e.screenX);
  if (startMouseX && movement > DRAG_DELTA_PX) {
    // x-axis drag happened; block click
    e.preventDefault();
    return false;
  }
  item.onClick && item.onClick(e);
};

export const Tab = (props) => <div className={classnames(styles.Tabs, props.className)}>
  <ul className={styles.Tabs_mainContent}>
    {props.items.map((item) => {
      const linkTitle = item.text && item.text.replace(/\s+|'|&/g, '');
      const className = classnames(styles.Tabs_mainContent_item,
        testClass(`${linkTitle}-link`),
        {
          [styles.__active]: item.isActive,
        });
      const pureTextClassName = classnames({
        [styles.Tabs_mainContent_item_disabled]: item.isDisabled,
      });
      if (! item[TAB_ITEM_ONCLICK_KEY]) {
        item[TAB_ITEM_ONCLICK_KEY] = onClick.bind(null, item);  // eslint-disable-line
      }
      return <li key={item.text}
          className={className}>
        {item.href ?
          <Link to={item.href}
              draggable={false}
              onMouseDown={onMouseDown}
              onClick={item[TAB_ITEM_ONCLICK_KEY]}>
            {item.text}
          </Link> :
          <span className={pureTextClassName}
              onClick={item[TAB_ITEM_ONCLICK_KEY]}>
            {item.text}
          </span>}
      </li>;
    })}
  </ul>
</div>;

Tab.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      onClick: PropTypes.func,
      isActive: PropTypes.bool,
      isDisabled: PropTypes.bool,
    })),
};

export default pure(Tab);



// WEBPACK FOOTER //
// ./components/TabNav/Tabs/index.jsx